import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarPinnedOpen, setSidebarPinnedOpen] = useState(() => {
    try {
      return localStorage.getItem('sidebar-pinned-open') === 'true';
    } catch {
      return false;
    }
  });

  const toggleSidebarPinned = () => {
    setSidebarPinnedOpen((open) => {
      const nextOpen = !open;
      try {
        localStorage.setItem('sidebar-pinned-open', String(nextOpen));
      } catch {
        // Sidebar preference is still usable when localStorage is unavailable.
      }
      return nextOpen;
    });
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar
        isOpen={sidebarOpen}
        isPinnedOpen={sidebarPinnedOpen}
        onTogglePinned={toggleSidebarPinned}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="relative z-10 flex flex-1 flex-col overflow-hidden">
        <Header onMenuToggle={() => setSidebarOpen((o) => !o)} />

        <main className="min-h-0 flex-1 overflow-y-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
